import { render, staticRenderFns } from "./AccountBankAddEdit.vue?vue&type=template&id=ef61f4e8"
import script from "./AccountBankAddEdit.vue?vue&type=script&lang=js"
export * from "./AccountBankAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports